import _ from 'lodash';

export default class Company {
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.Vue = Vue;
    this.init();
  }

  init() {
    this.json = '';

    [this.locationJson] = window.location.href
      .replace('http://www.', '')
      .replace('https://www.', '')
      .replace('http://', '')
      .replace('https://', '')
      .replace(':8085', '')
      .replace(':8081', '')
      .replace(':80', '')
      .replace(':7171', '')
      .split('/');

    if (window.getParameterByName('portalUrl')) this.locationJson = window.getParameterByName('portalUrl');

    this.domain = this.locationJson;

    this.moduleOpen = '';
    this.itemOpen = '';

    this.itemScriptLoading = false;
    this.closeScriptVisible = true;

    this.scriptFluid = false;

    this.sumValueListLoading = [];

    this.companyLogoVisibility = true;
  }

  /**
   * =======
   * MODULE
   * =======
   */

  openModule(m, i) {
    if (
      (
        this.moduleOpen
        && this.itemOpen
        && this.moduleOpen.id === m.id
        && this.itemOpen.id === i.id
      )
      || this.itemScriptLoading
      || (
        i.sumSql
        && i.sumError
      )
    ) return;

    this.closeScriptVisible = true;
    this.companyLogoVisibility = true;

    this.moduleOpen = m;
    this.itemOpen = i;
  }

  /**
   * @LEGACY
   * ABRE O MÓDULO COM BASE NO PARÂMETRO PASSADO
   */
  openModuleItem(m, i, bypassLoading = false) {
    if (!bypassLoading && (this.itemScriptLoading || (i.sumSql && (!i.sumValue || i.sumError)))) return;

    this.closeModuleItem();
    this.closeScriptVisible = true;
    this.companyLogoVisibility = true;

    setTimeout(() => {
      this.moduleOpen = m;
      this.itemOpen = i;
    }, 20);
  }

  // FECHA O MÓDULO, E PODE SER PASSADO UM PARAMETRO PARA INFORMAR SE FOI ERRO.
  closeModuleItem(err) {
    this.moduleOpen = '';
    this.itemOpen = '';
    if (err) {
      console.log(err);
      brain.connectionError(err);
    }
  }

  disableScriptLoading() {
    this.itemScriptLoading = false;
  }

  /**
   * =====
   * JSON
   * =====
   */

  // FAZ O REALOAD PADRÃO DO JSON DA COMPANY
  reloadJson() {
    return new Promise((resolve, reject) => {
      this.downloadJsonByDomain()
        .then(res => this.formatJson(res))
        .then(res => {
          this.json = res;
        })
        .then(() => resolve(200))
        .catch(res => reject(res));
    });
  }

  // BAIXA A ESTRUTURA DO JSON DA COMPANY
  downloadJsonByDomain() {
    return new Promise((resolve, reject) => {
      const errorCode = '#ERRO_DOWNLOAD_COMPANY';
      this.utils.getCompany(this.locationJson)
        .then(res => {
          let json = {};
          try {
            json = JSON.parse(res);
          } catch (err) {
            json = res;
          }

          if (!json) return reject(errorCode);
          return resolve(json);
        })
        .catch(err => {
          const errorObj = {
            code: errorCode,
            stack: _.get(err, 'stack') || _.get(err, 'message') || err,
          };
          console.error(errorObj);
          return reject(errorObj);
        });
    });
  }

  // FORMATA O JSON DA COMPANY ADICIONANDO PARÃMETROS NECESSÁRIOS
  formatJson(json) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(_.get(json, 'module'))) return reject({ code: '#MODULE_IS_NOT_ARRAY', stack: { message: 'json.module is not an array', json } });

      json.module.forEach(m => {
        if (!m || !Array.isArray(m.item)) return;

        m.item.forEach(i => {
          if (!i) return;
          i.sumError = false;
          if (!i.sumValue) i.sumValue = '';
          if (!i.sumType) i.sumType = '';
          if (!i.sumSql) i.sumSql = '';
        });
      });

      return resolve(json);
    });
  }

  updateModulesByOpenScript() {
    return new Promise((resolve, reject) => {
      this.downloadJsonByDomain()
        .then(res => this.formatJson(res))
        .then(res => {
          if (!Array.isArray(res.module)) throw { stack: { message: 'res.module is not an array', res } };

          res.module.forEach(m => {
            if (!m) return;

            const module = this.json.module.find(j => j.id === m.id);

            m.item.forEach(i => {
              if (!i) return;

              const item = i;
              const existent = _.get(module, 'item', []).find(j => j.id === item.id);

              if (existent) {
                item.sumError = existent.sumError;
                item.sumValue = existent.sumValue;
              }
            });
          });

          this.json = res;

          if (!this.moduleOpen)
            throw new Error('Nenhum módulo aberto.');

          this.moduleOpen = this.json.module.find(i => i.id === this.moduleOpen.id);
          this.itemOpen = this.moduleOpen.item.find(i => i.id === this.itemOpen.id);

          return resolve();
        })
        .catch(err => {
          const stack = _.get(err, 'stack') || _.get(err, 'message');
          const errorCode = _.get(err, 'code');
          const errObj = {
            code: '#ERRO_RELOAD_COMPANY_BY_OPEN_SCRIPT',
            error: {
              stack,
              code: errorCode,
            },
            origin: _.get(window, 'location.href'),
          };
          console.error(errObj);
          return reject(errObj);
        });
    });
  }

  setItemModuleSumValue(moduleId, itemId, value) {
    const item = this.findItemModuleObject(moduleId, itemId);
    if (!item) return;
    item.sumValue = value;
  }

  setItemModuleSumError(moduleId, itemId) {
    const item = this.findItemModuleObject(moduleId, itemId);
    if (!item) return;
    item.sumError = true;
  }

  setSumErrorActivity(error) {
    brain.setActivity('connectionErrorSum', error, true);
  }

  findItemModuleObject(moduleId, itemId) {
    const module = this.json.module.find(m => m.id === moduleId);
    if (!module || !Array.isArray(module.item)) return console.log('Erro ao setar o sumValue! Módulo não encontrado!');
    const item = module.item.find(i => i.id === itemId);
    if (!item) return console.log('Erro ao setar o sumValue! Item não encontrado!');
    return item;
  }

  getPasswordValidationRules() {
    const rule = _.get(this.json, 'passwordValidation.rules', {
      min: {
        value: 4,
      },
      max: {
        value: undefined,
      },
    });
    if (rule.min.value < 4) rule.min.value = 4;
    return rule;
  }

  /**
   * DEVE SER REFATORADO
   */
  reloadSumValue() {
    if (this.sumValueListLoading.length > 0) return;
    // Fecha o script aberto caso o reload de valores for chamado
    if (this.itemOpen) this.closeModuleItem();

    this.json.module.forEach(m => {
      m.item.forEach(i => {
        i.sumError = false;
        if (i.sumSql && i.sumSql.length > 5) {
          i.sumValue = '';
          if (i.connector) {
            // EXECUTA O SQL PARA ATUALIZAR O SUM VALUE
            this.sumValueListLoading.push({ module: m.id, item: i.id });

            this.utils.remoteSqlCore.executeSql({
              sql: i.sumSql,
              connector: i.connector,
              requestSizeLimit: i.sumSqlRequestSizeLimit,
              timeout: 30000,
            })
              .then(res => {
                this.sumValueListLoading = this.sumValueListLoading
                  .filter(j => !(j.module === m.id && j.item === i.id));

                let result = 0;
                res.rows.forEach(r => {
                  if (!r || Number.isNaN(Number(r.valueSum))) return;
                  result += Number(r.valueSum);
                });

                if (i.sumType === 'currency') {
                  if (result === 'null') {
                    this.setItemModuleSumValue(m.id, i.id, 'R$ 0,00');
                  } else {
                    this.setItemModuleSumValue(m.id, i.id, new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(result));
                  }
                }
              })
              .catch(err => {
                this.sumValueListLoading = this.sumValueListLoading
                  .filter(j => !(j.module === m.id && j.item === i.id));

                this.setItemModuleSumError(m.id, i.id);
                this.setSumErrorActivity({
                  module: m.id,
                  item: i.id,
                  sql: i.sumSql,
                  connector: i.connector,
                  error: err,
                });
                console.log(err);
                console.log(`Ocorreu um erro no SQL do item: ${i.id}!`);
              });
          } else {
            this.setItemModuleSumError(m.id, i.id);
            console.log(`O item: ${i.id}, não pode ser executado pois não possui conector!`);
          }
        }
      });
    });
  }

  getAppName() {
    return this.json.appName || '';
  }

  /** MODULE */
  getGroupsFromModule(module) {
    if (!this.json || !_.has(module, 'role.groups') || !_.isArray(module.role.groups)) return [];
    return module.role.groups;
  }

  isEntityAutoValidate() {
    if (_.has(this.json, 'entity.autoValidate.sql') && _.has(this.json, 'entity.autoValidate.connector')) return true;
    return false;
  }

  isEntityQuestion() {
    if (_.has(this.json, 'entity.question.sql') && _.has(this.json, 'entity.question.connector') && _.has(this.json, 'entity.question.description')) return true;
    return false;
  }

  isEntityMFA() {
    if (_.has(this.json, 'entity.mfa')) return true;
    return false;
  }

  isEntityApproval() {
    if (_.has(this.json, 'entity.approval')) return true;
    return false;
  }

  /** NOTIFICATIONS */

  hasNotificationsSettings(type) {
    if (!this.json.notifications)
      return false;

    if (type)
      return !!this.json.notifications?.[type]?.status;

    const hasNotifications = Object.keys(this.json.notifications).some(item => this.json.notifications[item].status === true);

    return hasNotifications;
  }

  hasPhoneConfiguredInNotifications() {
    if (!this.json.notifications)
      return false;

    return ['whatsapp', 'sms'].some(type => this.json?.notifications?.[type]?.status === true);
  }
}
